import React, {Fragment} from "react";
import LocalBeaconTable from 'components/shared/Table/BeaconTable';
import './ShareClassConversionTable.scss'
import ShareClassConversionModal from 'components/shared/ShareClassConversion/ShareClassConversionModal';
import {Dollar, Quantity} from 'components/shared/Text/Text';
import { mmddyyyy } from 'services/Dates';
import {ShareClassTableNameString} from 'services/Content';
const ShareClassConversionTable = ({portfolioAsOfDate, conversionHistory}) => {

 let tableEditedConversionHistory = []
  conversionHistory?.map((conversion) => {
    tableEditedConversionHistory.push(
      [
        {
          record: ShareClassTableNameString[conversion?.conversionType],
          variant: "text"
        },
        {
          record: <Quantity>{conversion?.shareQuantity}</Quantity>,
          variant: "text"
        },
        {
          record: <Dollar>{conversion?.totalTransactionAmount}</Dollar>,
          variant: "text"
        },
        {
          record: mmddyyyy(conversion?.tradeDate, '/'),
          variant: "text"
        }
        ]
    )
  });
  return (
    <Fragment>
      <div className="transactions-share-class-table-container module-container">
        <div className="account-details-historical-transactions">
          <h2 className="account-details-graph-header flex-header">
            Share Class Conversion
          </h2>
          <div className="as-of-date-share-class">
            As of {mmddyyyy(portfolioAsOfDate, '/')}
          </div>
          <LocalBeaconTable
            classType={"beacon-on-light"}
            idName={"share-class-beacon-table"}
            headers={
              [
                {
                  id: "activity",
                  title: "Activity",
                  variant: "group"
                },
                {
                  id: "quantity",
                  title: "Quantity",
                  variant: "group"
                },
                {
                  id: "net-dollar-amount",
                  title: "Net Dollar Amount",
                  variant: "group"
                },
                {
                  id: "trade-date",
                  title: "Trade Date",
                  variant: "group"
                },
              ]
          }
            rowsArray={tableEditedConversionHistory}
          />
          <div className="share-class-modal-link">
            <ShareClassConversionModal
              icon={
                <div>
                  <span className="view-more-link-share-class">
                    Important Information
                  </span>
                </div>
              }
            />
          </div>
        </div>
      </div>
    </Fragment>
  );
};


export default ShareClassConversionTable;
